/**
 * Affiliate network definitions.
 * Used by AdminBrandForm (dropdown) and AdminAffiliates (listing).
 */

export interface AffiliateNetworkInfo {
  name: string;
  website: string;
  type: string; // e.g. 'Referral', 'CPA Network', 'Direct'
  notes: string;
}

export const AFFILIATE_NETWORKS: AffiliateNetworkInfo[] = [
  {
    name: 'Katalys',
    website: 'https://katalys.com',
    type: 'CPA Network',
    notes: 'Formerly RevOffers. Performance-based affiliate network for cannabis/CBD brands.',
  },
  {
    name: 'Lazarus Naturals',
    website: 'https://www.lazarusnaturals.com',
    type: 'Direct',
    notes: 'Direct affiliate program with Lazarus Naturals.',
  },
  {
    name: 'Try Sprinkle',
    website: 'https://trysprinkle.com',
    type: 'Referral',
    notes: 'Simple referral code program (?ref=CODE style).',
  },
];

/** Just the network names — for use in dropdowns */
export const AFFILIATE_NETWORK_NAMES = AFFILIATE_NETWORKS.map((n) => n.name);
